export default __webpack_public_path__ + "static/media/anagrafica_stampe.283a955d.less";